import * as React from "react";

export const DownloadIcon: React.FC<{
  color?: string;
  iconColor?: string;
  size?: number;
  title?: string;
}> = ({
  color,
  iconColor = "#017E72",
  size = 24,
  title,
}): React.ReactElement => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <title>{title}</title>
    <rect
      className="download-rect"
      width="24"
      height="24"
      rx="2"
      fill={color || "#CEEAE3"}
    />
    <path
      d="M15.1812 10.2353H14.0588V6.70588C14.0588 6.31765 13.7412 6 13.3529 6H10.5294C10.1412 6 9.82353 6.31765 9.82353 6.70588V10.2353H8.70118C8.07294 10.2353 7.75529 10.9976 8.2 11.4424L11.44 14.6824C11.7153 14.9576 12.16 14.9576 12.4353 14.6824L15.6753 11.4424C16.12 10.9976 15.8094 10.2353 15.1812 10.2353ZM7 17.2941C7 17.6824 7.31765 18 7.70588 18H16.1765C16.5647 18 16.8824 17.6824 16.8824 17.2941C16.8824 16.9059 16.5647 16.5882 16.1765 16.5882H7.70588C7.31765 16.5882 7 16.9059 7 17.2941Z"
      fill={iconColor}
    />
  </svg>
);
